import { authActions } from "./auth.action";
import { defiActions } from "./defi.action";
import { userActions } from "./user.action";
import { web3Actions } from "./web3.action";

// Define the type for the combined actions object
export type Actions = typeof authActions &
  typeof userActions &
  typeof defiActions &
  typeof web3Actions & {
    getCreators: (params?: any) => (dispatch: any) => Promise<void>;
    getSecondaryMarketplaceMetrics: () => (dispatch: any) => Promise<void>;
  };

export const actions = {
  ...userActions,
  ...authActions,
  ...defiActions,
  ...web3Actions,
  filterRentalProperties: authActions.filterRentalProperties,
} as Actions;
